
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BrandPresentation, getBrandPresentation } from '../../domain/brand-presentation';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class LogoComponent {
  presentation: BrandPresentation = getBrandPresentation('');

  @Input()
  set siteBrand(value: string) {
    this.presentation = getBrandPresentation(value);
  }
}
